import { Database, Server } from "lucide-react";

import { Layout } from "lucide-react";

import { Zap } from "lucide-react";

export const TECH_STACK = [
  {
    icon: <Zap className="h-6 w-6" />,
    title: "极速运行",
    description:
      "使用叠加技术，实现极速运行",
  },
  {
    icon: <Layout className="h-6 w-6" />,
    title: "Shadcn UI",
    description:
      "使用 Shadcn UI 组件库，实现美观且可访问的用户界面",
  },
  {
    icon: <Database className="h-6 w-6" />,
    title: "高吞吐量",
    description: "使用 HonoJS 框架，实现高吞吐量的后端服务",
  },
  {
    icon: <Server className="h-6 w-6" />,
    title: "基于 Ollen Core 构建",
    description: "使用 Ollen Core 运行服务，实现高可扩展性和高可用性",
  },
];
